import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const BiomeIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 128 128"><path fill="#60a5fa" d="M64 8.584 35.487 57.967a64.358 64.358 0 0 1 33.735-1.17l9.635 2.27-9.054 38.429-9.665-2.261c-11.855-2.802-23.23 3.421-28.053 13.356l-8.924-4.312C29.964 90.222 46 81.719 62.429 85.6l4.522-19.159A54.419 54.419 0 0 0 20.67 76.736 54.469 54.469 0 0 0 0 119.416h128zm0 0" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BiomeIcon;